/* eslint-disable */
(function( $ ) {

	var openedInfoWindow = false

	/**
	 * initMap
	 *
	 * Renders a Google Map onto the selected jQuery element
	 *
	 * @since   2023.1
	 * @param   jQuery $el The jQuery element.
	 * @return  object The map instance.
	 */
	 var initializeBlock = function initMap( $el ) {
	
			// Find marker elements within map.
			var $markers = $el.find('.js-marker');
	
			// Create gerenic map.
			var mapArgs = {
					zoom        : $el.data('zoom') || 16,
					mapTypeId   : google.maps.MapTypeId.ROADMAP,
					// mapTypeControlOptions: {
					// 	mapTypeIds: []
					// },
					// disableDefaultUI: true,
					// styles: [    
					// 	{
					// 			featureType: "poi",
					// 			elementType: "labels",
					// 			stylers: [{ visibility: "off" }]
					// 	},
					// 	{
					// 		featureType: "transit.station.bus",
      		// 		stylers:  [{ "visibility": "off" }]
					// 	},
					// 	{
					// 		featureType: "transit.station.rail",
      		// 		stylers:  [{ "visibility": "off" }]
					// 	}
					// ]
			};
			var map = new google.maps.Map( $el[0], mapArgs );
	
			// Add markers.
			map.markers = [];
			$markers.each(function(){
					initMarker( $(this), map );
			});
	
			// Center map based on markers.
			centerMap( map );
	
			// Return map instance.
			return map;
	}
	
	/**
	 * initMarker
	 *
	 * Creates a marker for the given jQuery element and map.
	 *
	 * @since   2023.1
	 * @param   jQuery $el The jQuery element.
	 * @param   object The map instance.
	 * @return  object The marker instance.
	 */
	function initMarker( $marker, map ) {
	
			// Get position from marker.
			var lat = $marker.data('lat');
			var lng = $marker.data('lng');
			var latLng = {
					lat: parseFloat( lat ),
					lng: parseFloat( lng )
			};
	
			// Create marker instance.
			var marker = new google.maps.Marker({
					position : latLng,
					map: map
			});
	
			// Append to reference for later use.
			map.markers.push( marker );
	
			// If marker contains HTML, add it to an infoWindow.
			if( $marker.html() ){
				// Create info window.
				var infowindow = new google.maps.InfoWindow({
					content: $marker.html()
				});

				// Show info window when marker is clicked.
				google.maps.event.addListener(marker, 'click', function() {
					closeLastOpenedInfoWindow();
					infowindow.open( map, marker );
					openedInfoWindow = infowindow;
				});
			}
	}

	/**
	* Closes all infoWindow instances.
	*/
	function closeLastOpenedInfoWindow() {
		if (openedInfoWindow) {
			openedInfoWindow.close();
		}
	}
	
	/**
	 * centerMap
	 *
	 * Centers the map showing all markers in view.
	 *
	 * @since   2023.1
	 * @param   object The map instance.
	 * @return  void
	 */
	function centerMap( map ) {
	
			// Create map boundaries from all map markers.
			var bounds = new google.maps.LatLngBounds();
			map.markers.forEach(function( marker ){
					bounds.extend({
							lat: marker.position.lat(),
							lng: marker.position.lng()
					});
			});
	
			// Case: Single marker.
			if( map.markers.length == 1 ){
					map.setCenter( bounds.getCenter() );
	
			// Case: Multiple markers.
			} else{
					map.fitBounds( bounds );
			}
	}
	
	// Render maps on page load.
	$(document).ready(function(){
			$('.js-map').each(function(){
				initializeBlock( $(this) );
			});
	});

	// Initialize dynamic block preview (editor).
	if( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=map', initializeBlock );
	}
	
})(jQuery);